module.exports = __webpack_public_path__ + "img/hopways.cb647c56.webp";